<dialog class="user-profile-dialog">
  <div class="content">
    <div class="user-container">
      <div class="avatar-image" [ngStyle]="{ 'background-image': 'url(' + this.data.user.avatarImage + ')'}"></div>
      <div class="user-information-container">
        <h1 class="user-name">{{this.data.user.displayName}}</h1>
        <h2 class="user-location">{{this.data.user.location}}</h2>
      </div>
    </div>
    <div class="logout-container" *ngIf="this.data.logout">
      <Button class="logout-button" (click)="logout()" mat-dialog-close>
          <img src="../../../../assets/images/logoff_logo.svg" alt="Logoff Image">
          <p class="button-text">{{logoutText}} </p>
      </Button>
    </div>
  </div>
</dialog>


